module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/katarzyna-stelmach-b37ee6c60359abd6950dab75cb23a674.png";